import { Badge } from "@/components/ui/badge"
import { cn } from "@/lib/utils"
interface AppBadgeProps {
  getBadgeInfo: () => { bgColor: string; text: string }
}
export const AppBadge: React.FC<AppBadgeProps> = ({ getBadgeInfo }) => {
  const { bgColor, text } = getBadgeInfo()
  return (
    <Badge
      variant="outline"
      className="flex w-fit items-center gap-2 truncate rounded-full"
    >
      <div
        className={cn("size-2 rounded-full")}
        style={{ backgroundColor: bgColor }}
      />
      <span>{text}</span>
    </Badge>
  )
}
export default AppBadge
